
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sample-book",
      function () {
        return require("private-next-pages/sample-book.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sample-book"])
      });
    }
  